import { ActionReducerMap } from '@ngrx/store';
import { AppState } from '../models';
import { networkReducer } from './network.reducers';
import { userReducer } from './user.reducers';

export const appReducers: ActionReducerMap<AppState> = {
    user: userReducer,
    network: networkReducer,
};
